
export default {
  name: "FooterRights",
};
